import script from "./IrregularLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./IrregularLayout.vue?vue&type=script&setup=true&lang=ts"

import "./IrregularLayout.vue?vue&type=style&index=0&id=3a4b25c5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a4b25c5"]])

export default __exports__